export default {
  bills: [],
};
